import { render, staticRenderFns } from "./DevolutivaAvaliacao.vue?vue&type=template&id=9f5a5646&scoped=true"
import script from "./DevolutivaAvaliacao.vue?vue&type=script&lang=js"
export * from "./DevolutivaAvaliacao.vue?vue&type=script&lang=js"
import style0 from "./DevolutivaAvaliacao.vue?vue&type=style&index=0&id=9f5a5646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5a5646",
  null
  
)

export default component.exports